/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// @mui material components
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";


import { CustomToastContent } from "../../../examples/CustomToastContent/index";

// React-Select component and styling
import Select from "react-select";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  createCompliance,
  createDynamicColumn,
  deleteCompliance,
  editCompliance,
  getAcn,
  getCompliance,
  getDppDocumentsImage,
  getDppIds,
  getDynamicColumn,
  getItemMaster,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLevelsByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocation,
  getSubModulesByRoleId,
  getSupplierType,
  getWarehouses,
  getWarehousesByMovement,
  getZonesByWarehouse,
  uploadForCompliance,
  uploadForUrl,
} from "../../../store";

// Cookies
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import EditButton from "components/standardized-components/EditButton";
import UploadButton from "components/standardized-components/UploadButton";
import { format } from "date-fns";
import { CSVLink } from "react-csv";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 850 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 900 },
  height: { xs: 250, lg: 700 },
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Compliance = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deleteCompliance,
  warehouses,
  getCompliance,
  getComplianceReducer,
  getItemMaster,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editCompliance,
  getAcn,
  getAcnReducer,
  getRelationLocation,
  createCompliance,
  getWarehousesByMovement,
  uploadForCompliance,
  getLevelsByWarehouse,
  levelsByWarehouseReducer,
  getDppIds,
  dppIdSelectedForGlobalFilter,
  uploadForUrl,
  getDynamicColumnReducer,
  getDPPReducer,
  getDppDocumentsImageReducer,
  getDppDocumentsImage,
  getSupplierType,
  getSupplierTypeReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "013a3276-d1db-4051-b489-b199b4710cf4",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "7e546bc8-f709-47c2-977c-1d519eea139c",
      )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "3dce3a16-274c-4937-92cc-df13fa7c6c8d",
      )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "dcc74deb-7702-47e5-8c9b-3a56621e4ff8",
      )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "8b83ab14-5e09-4de8-899f-13b7c9d2390b",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  // useEffect(() => {
  //   getCompliance(jwtToken);
  // }, []);

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  const euBatteryRegOptions = [
    {
      label: "EU Battery Regulation 2023/1542",
      value: "EU Battery Regulation 2023/1542",
    },
  ];
  const envComplianceOptions = [{ label: "ISO 14001", value: "ISO 14001" }];
  const euRecyclingOptions = [
    { label: "Regulation (EU) 2025/606", value: "Regulation (EU) 2025/606" },
  ];
  const euLabelingOptions = [
    {
      label: "Regulation (EU) 2023/1542 - Article 13 - Annex VI",
      value: "Regulation (EU) 2023/1542 - Article 13 - Annex VI",
    },
  ];

  const getDropdownOption = (val, optionsArray) => {
    return val !== undefined && val !== null
      ? optionsArray.find((o) => o.value === val) || ""
      : "";
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Compliance ID", accessor: "complianceId" },
      { Header: "DPP Code", accessor: "dppCode" },
      { Header: "Supplier ID", accessor: "supplierId" },
      {
        Header: "audit Date",
        accessor: "auditDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value ? format(new Date(value), "dd/MM/yyyy") : "";
        },
      },
      { Header: "Standard", accessor: "complianceStandard" },
      { Header: "Audit Result", accessor: "auditResult" },
      { Header: "Corrective Actions	", accessor: "correctiveActions" },
      {
        Header: "file",
        accessor: "file",
        cannotSearch: true,
        cannotSort: true,
      },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  // const headers = [
  //   { label: "complianceId", key: "complianceId" },
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "supplierId", key: "supplierId" },

  //   // Date field
  //   { label: "auditDate", key: "createdDate" },

  //   { label: "complianceStandard", key: "complianceStandard" },
  //   { label: "auditResult", key: "auditResult" },
  //   { label: "correctiveActions", key: "correctiveActions" },

  //   // Action (optional)
  //   // { label: "action", key: "action" }
  // ];
  // const headersForTemp = [
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "supplierName", key: "supplierName" },
  //   { label: "auditDate", key: "auditDate" },
  //   { label: "complianceStandard", key: "complianceStandard" },
  //   { label: "auditResult", key: "auditResult" },
  //   { label: "correctiveActions", key: "correctiveActions" },
  //   { label: "complianceScore", key: "complianceScore" },
  //   { label: "orderNo", key: "orderNo" },
  // ];

  // --- 1. Table Data Download (Listing) ke Headers ---
  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "Supplier Name", key: "supplierName" },
    { label: "Audit Date", key: "createdDate" },
    { label: "Compliance Standard", key: "complianceStandard" },
    { label: "Audit Result", key: "auditResult" },
    { label: "Corrective Actions", key: "correctiveActions" },

    // { label: "Compliance ID", key: "complianceId" },
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "supplierName", key: "supplierName" },
    { label: "auditDate", key: "auditDate" },
    { label: "complianceStandard", key: "complianceStandard" },
    { label: "auditResult", key: "auditResult" },
    { label: "correctiveActions", key: "correctiveActions" },
  ];

  const { columns, rows } = state;
  const csvLink = {
    filename: "Compliance List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Compliance Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getComplianceReducer.compliance.data
      ? getComplianceReducer.compliance.data
      : [];
    console.log(data);
    // setPaginationObj(getComplianceReducer?.compliance?.pagination);
    setLoading(getComplianceReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.auditDate);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${
          itemDescription ? itemDescription.substring(0, len) : ""
        }`,
        complianceId: item.complianceId,
        dppCode: item.dppCode,
        supplierId: item.supplierId,
        dppId: item.dppId,
        complianceStandard: item.complianceStandard,
        auditResult: item.auditResult,
        auditDate: item.auditDate,
        correctiveActions: item.correctiveActions,
        itemCode: item.itemCode,

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,

        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        file: item.name ? (
          <MDButton
            variant="gradient"
            color="info"
            iconOnly
            size="small"
            style={{ padding: "4px", minWidth: "32px" }}
            onClick={() => handleOpenDocument(item)}
          >
            <Icon>description</Icon>
          </MDButton>
        ) : (
          "-"
        ),
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getComplianceReducer]);

  const [currentFile, setCurrentFile] = useState(null);

  const handleOpenDocument = (item) => {
    // Trigger API call
    getDppDocumentsImage(item.moduleName, item.type, item.name, jwtToken);
  };

  // Watch reducer for updates
  useEffect(() => {
    const data = getDppDocumentsImageReducer.documents.data;

    if (data) {
      // Set the file for temporary use
      setCurrentFile(data);

      // Reset local state in reducer copy
      getDppDocumentsImageReducer.documents.data = null; // clears it locally
    }
  }, [getDppDocumentsImageReducer.documents.data]);

  // Optional: automatically clear currentFile after some time
  useEffect(() => {
    if (currentFile) {
      const timer = setTimeout(() => setCurrentFile(null), 1000); // 5 seconds
      return () => clearTimeout(timer);
    }
  }, [currentFile]);

  // Open file whenever currentFile updates
  useEffect(() => {
    if (!currentFile) return;

    let fileUrl;
    if (typeof currentFile === "string") fileUrl = currentFile;
    else if (currentFile.url) fileUrl = currentFile.url;
    else if (currentFile.base64) {
      const byteCharacters = atob(currentFile.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: currentFile.type || "application/octet-stream",
      });
      fileUrl = URL.createObjectURL(blob);
    } else return;

    window.open(fileUrl, "_blank", "noopener,noreferrer");
  }, [currentFile]);

  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    [],
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  // useEffect(() => {
  //   getLevelsByWarehouse(warehouseIdSelected?.value, jwtToken);
  // }, [warehouseIdSelected]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);
  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setZoneIdSelected("");
    setWarehouseIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setAllocateItemModal(!allocateItemModal);

    formik.setValues(initialValues);
    setdppIdSelected("");
    setSupplierIdSelected("");

    formik.setErrors({});
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName,
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };

  //  dppId: values.DPPID,
  // auditResult: values.AuditResult,
  // auditDate: values.AuditDate,
  // supplierId: values.SupplierID,
  // complianceStandard: values.ComplianceStandard,
  // correctiveActions: values.CorrectiveActions,
  // certificateUrl: values.CertificateURL,

  const initialValues = {
    DPPID: "",
    AuditResult: "",
    AuditDate: "",
    SupplierID: "",
    ComplianceStandard: "",
    CorrectiveActions: "",
    CertificateURL: "",

    eUBatteryRegulation: "",
    environmentalComplianceDeclaration: "",
    eURecyclingCommissionRegulation: "",
    euLabelingCompliance: "",
    // rackName: "",
    // bin: "",
  };

  const validationSchema = Yup.object({
    //  DPPID: Yup.object()
    //      .required("Select DPP Code"),

    AuditResult: Yup.string().trim().required(" "),

    AuditDate: Yup.date()
      .typeError("AuditDate must be a valid date")
      .required(" "),

    // SupplierID: Yup.string()
    //   .trim()
    //   .required("SupplierCode is required"),

    ComplianceStandard: Yup.string().trim().required(" "),

    CorrectiveActions: Yup.string().trim().required(" "),

    eUBatteryRegulation: Yup.object(),
    environmentalComplianceDeclaration: Yup.object(),
    eURecyclingCommissionRegulation: Yup.object(),
    euLabelingCompliance: Yup.object(),

    // Optional fields if needed:
    // rackName: Yup.string().trim().required("rackName is required"),
    // bin: Yup.string().trim().required("bin is required"),
  });

  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");
  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");

    const formData = new FormData();

    formData.append("cdBy", userId);
    formData.append("dppId", dppIdSelected?.value);
    formData.append("auditResult", values.AuditResult);
    formData.append("auditDate", values.AuditDate);
    // formData.append("supplierId", values.SupplierID);

    formData.append("supplierId", supplierIdSelected?.value);
    formData.append("complianceStandard", values.ComplianceStandard);
    formData.append("correctiveActions", values.CorrectiveActions);
    formData.append("certificateUrl", values.CertificateURL);
    formData.append("documentType", "complianceImage");
    formData.append("moduleName", "socialComplaince");

    formData.append(
      "eUBatteryRegulation",
      values.eUBatteryRegulation?.value || "",
    );
    formData.append(
      "environmentalComplianceDeclaration",
      values.environmentalComplianceDeclaration?.value || "",
    );
    formData.append(
      "eURecyclingCommissionRegulation",
      values.eURecyclingCommissionRegulation?.value || "",
    );
    formData.append(
      "euLabelingCompliance",
      values.euLabelingCompliance?.value || "",
    );

    // ✅ attach compliance certificate
    if (values.file) {
      formData.append("attachments", values.file);
    }

    let res = await createCompliance(formData, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      getOpenBinsByWarehouseAndZone(warehouseIdSelected?.value, zoneIdSelected);
      getCompliance(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});

      setActivityIdSelected("");
      setWarehouseIdSelected("");
      setZoneIdSelected("");
      setSectionIdSelected("");
      setRackIdSelected("");
      setLocationIdSelected("");

      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2250);
    } else {
      setErrorMsg(res?.data?.data?.msg);
      setAllocateButtonName("Create");
      setIsErrorAllocateItem(true);
    }

    setSelectedItemCode("");
    setSelectedZoneName("");
    setSelectedBin("");
    // resetForm();
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };
  useEffect(() => {
    getSupplierType(jwtToken);
  }, []);
  const [supplierOptions, setSupplierOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getSupplierTypeReducer.dpp.data
      ? getSupplierTypeReducer.dpp.data
      : [];
    console.log("datasdsds", data);
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.supplierName,
        value: zone.supplierId,
      });
    });
    setSupplierOptions(tempgetDPPReducer);
  }, [getSupplierTypeReducer]);

  const [supplierIdSelected, setSupplierIdSelected] = useState("");

  const handleChangeSupplier = (selectedData) => {
    setSupplierIdSelected(selectedData);
  };
  const [supplierIdSelectedForEdit, setSupplierIdSelectedForEdit] =
    useState("");

  const handleChangeSupplierForEdit = (selectedData) => {
    setSupplierIdSelectedForEdit(selectedData);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let complianceId = singleDataForDelete.complianceId;
    // let userId = singleDataForDelete.userId;

    let res = await deleteCompliance(complianceId);

    if (res.status) {
      getCompliance(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getCompliance(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = (singleData) => {
    getWarehousesByMovement(singleData.acnId, jwtToken);
    // getZonesByWarehouse(singleData.zoneId, jwtToken);
    getLevel1ByLevel(singleData.warehouseId, 0, jwtToken);
    getLevel2ByLevel(singleData.warehouseId, singleData.zoneId, jwtToken);
    getLevel3ByLevel(singleData.warehouseId, singleData.sectionId, jwtToken);
    getLevel4ByLevel(singleData.warehouseId, singleData.rackId, jwtToken);
    setWarehouseTypesSelectedForEdit({
      label: singleData.warehouseCode,
      value: singleData.warehouseId,
    });
    setItemCodeSelectedForEdit({
      label: singleData.itemCode,
      value: singleData.itemId,
    });
    setSupplierIdSelectedForEdit({
      label: singleData.supplierName,
      value: singleData.supplierId,
    });
    setAcnTypeSelectedForEdit({
      label: singleData.acnCode,
      value: singleData.acnId,
    });
    setZoneSelectedForEdit({
      label: singleData.zone,
      value: singleData.zoneId,
    });
    setSectionSelectedForEdit({
      label: singleData.section,
      value: singleData.sectionId,
    });
    setRackSelectedForEdit({
      label: singleData.rack,
      value: singleData.rackId,
    });
    setLocationSelectedForEdit({
      label: singleData.location,
      value: singleData.locationId,
    });
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };

  //   dppId: values.DPPID,
  // auditResult: values.AuditResult,
  // auditDate: values.AuditDate,
  // supplierId: values.SupplierID,
  // complianceStandard: values.ComplianceStandard,
  // correctiveActions: values.CorrectiveActions,
  // certificateUrl: values.CertificateURL,

  const initialValueForUpdate = {
    DPPID: singleFgDataForUpdate.dppCode,
    AuditResult: singleFgDataForUpdate.auditResult,
    AuditDate: singleFgDataForUpdate.auditDate
      ? (() => {
          const [month, day, year] = singleFgDataForUpdate.auditDate.split("/");
          return `${year}-${month}-${day}`;
        })()
      : "",

    SupplierID: singleFgDataForUpdate.supplierId,
    ComplianceStandard: singleFgDataForUpdate.complianceStandard,
    CorrectiveActions: singleFgDataForUpdate.correctiveActions,
    CertificateURL: singleFgDataForUpdate.certificateUrl,

    eUBatteryRegulation: getDropdownOption(
      singleFgDataForUpdate.eUBatteryRegulation,
      euBatteryRegOptions,
    ),
    environmentalComplianceDeclaration: getDropdownOption(
      singleFgDataForUpdate.environmentalComplianceDeclaration,
      envComplianceOptions,
    ),
    eURecyclingCommissionRegulation: getDropdownOption(
      singleFgDataForUpdate.eURecyclingCommissionRegulation,
      euRecyclingOptions,
    ),
    euLabelingCompliance: getDropdownOption(
      singleFgDataForUpdate.euLabelingCompliance,
      euLabelingOptions,
    ),
  };

  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [dppIdSelected, setdppIdSelected] = useState("");

  const handleChangeDpp = (selectedData) => {
    setdppIdSelected(selectedData);
  };

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter) {
      setdppIdSelected(dppIdSelectedForGlobalFilter);
    }
  }, [dppIdSelectedForGlobalFilter]);

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getCompliance(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getCompliance(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");
  const handleChangeDppForUpdate = (selectedData) => {
    setdppIdForUpdateSelected(selectedData);
  };
  useEffect(() => {
    getDppIds(jwtToken);
  }, []);

  const [editButtonName, setEditButtonName] = useState("Update");
  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");

    const formData = new FormData();

    formData.append("udBy", userId);
    formData.append("complianceId", singleFgDataForUpdate?.complianceId);
    formData.append("dppId", singleFgDataForUpdate.dppId);
    formData.append("auditResult", values.AuditResult);
    formData.append("auditDate", values.AuditDate);
    // formData.append("supplierId", values.SupplierID);

    formData.append("supplierId", supplierIdSelectedForEdit?.value);
    formData.append("complianceStandard", values.ComplianceStandard);
    formData.append("correctiveActions", values.CorrectiveActions);
    // formData.append("certificateUrl", values.CertificateURL);

    // ✅ attach new certificate only if selected
    formData.append("documentType", "complianceImage");
    formData.append("moduleName", "socialComplaince");

    formData.append(
      "eUBatteryRegulation",
      values.eUBatteryRegulation?.value || "",
    );
    formData.append(
      "environmentalComplianceDeclaration",
      values.environmentalComplianceDeclaration?.value || "",
    );
    formData.append(
      "eURecyclingCommissionRegulation",
      values.eURecyclingCommissionRegulation?.value || "",
    );
    formData.append(
      "euLabelingCompliance",
      values.euLabelingCompliance?.value || "",
    );
    if (values.file) {
      formData.append("attachments", values.file);
    }
    let res = await editCompliance(formData, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getCompliance(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForAssembly,
    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getCompliance(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});

const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadForCompliance(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        getCompliance(dppIdSelectedForGlobalFilter?.value, jwtToken);
        setUploadCsvFilter(false);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };


    const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const subModuleId = "013a3276-d1db-4051-b489-b199b4710cf4";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getCompliance(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  const [isUploading, setIsUploading] = useState(false);

  const uploadDocumentHandler = async () => {
    if (!formik.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    data.append("File", formik.values.file); // file
    data.append("module_name", "compliance"); // text

    try {
      const res = await uploadForUrl(data);
      console.log(res);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill Certificate URL
        formik.setFieldValue("CertificateURL", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      console.error(error);
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  const uploadDocumentHandlerForUpdate = async () => {
    if (!formikForUpdate.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    data.append("File", formikForUpdate.values.file);
    data.append("module_name", "compliance");

    try {
      const res = await uploadForUrl(data);
      // console.log(res);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill Proof Document URL
        formikForUpdate.setFieldValue("CertificateURL", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      console.error(error);
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  const hideProductImageUrl = true;

  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4}>
                {allocateAccess && (
                  <Tooltip>
                    <CreateButton
                      tooltip="Add Compliance"
                      color="info"
                      variant="contained"
                      type="button"
                      iconOnly
                      onClick={(event) => {
                        handleAllocateItemModal();
                        getWarehouses(jwtToken);
                        getItemMaster(jwtToken);
                        getAcn(jwtToken);
                        getRelationLocation(jwtToken);
                      }}
                      style={{ borderRadius: "5px" }}
                      size="small"
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </Tooltip>
                )}
                <CSVLink {...csvLink}>
                  <DownloadDataButton
                    tooltip="Download Compliance List"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadDataButton>
                </CSVLink>

                {
                  //  uploadFG &&
                  <UploadButton
                    tooltip="Upload CSV"
                    //   disabled={!uploadItem}
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="info"
                    iconOnly
                    onClick={uploadCsvFilterHandler}
                  >
                    <Icon>upload</Icon>
                  </UploadButton>
                }

                <CSVLink {...csvLink2}>
                  <DownloadButton
                    tooltip="Download Template"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                </CSVLink>
                {/* <Tooltip title="Upload CSV">
                    <MDButton
                      style={{ marginLeft: "1rem" }}
                      // disabled={!uploadItem}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </MDButton>
                  </Tooltip> */}
              </MDBox>
            </MDBox>

            {uploadCsvFilter && (
              <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />
                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div style={{ marginBottom: "-20px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  // serverSidePagination={true}
                  // paginationObj={paginationObj}
                  // pageNoValue={pageNo}
                  // rowsPerPageValue={rowsPerPage}
                  // pageNoProp={importPageNo}
                  // rowsPerPageProp={importRowsPerPage}
                  // searchProp={importSearch}
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={6}>
                          <MDBox>
                            <MDTypography variant="h6">DPP Code</MDTypography>
                            <MDInput
                              type="text"
                              name="DPPID"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DPPID}
                              error={
                                formikForUpdate.touched.DPPID &&
                                formikForUpdate.errors.DPPID &&
                                true
                              }
                              disabled={true}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DPPID &&
                              formikForUpdate.errors.DPPID && (
                                <TextError msg={formikForUpdate.errors.DPPID} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Supplier Name{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={200}
                              placeholder="Choose one..."
                              name="supplierId"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "supplierId" },
                                });
                              }}
                              value={supplierIdSelectedForEdit}
                              options={supplierOptions}
                              onChange={(selectedOption) => {
                                handleChangeSupplierForEdit(selectedOption);
                                // getZonesByWarehouse(selectedOption?.value);
                                formikForUpdate.setFieldValue(
                                  "supplierId",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForUpdate.touched.supplierId &&
                              formikForUpdate.errors.supplierId && (
                                <TextError
                                  msg={formikForUpdate.errors.supplierId}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">Audit Date</MDTypography>
                            <MDInput
                              type="date"
                              name="AuditDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.AuditDate}
                              error={
                                formikForUpdate.touched.AuditDate &&
                                formikForUpdate.errors.AuditDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.AuditDate &&
                              formikForUpdate.errors.AuditDate && (
                                <TextError
                                  msg={formikForUpdate.errors.AuditDate}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Compliance Standard
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="ComplianceStandard"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ComplianceStandard}
                              error={
                                formikForUpdate.touched.ComplianceStandard &&
                                formikForUpdate.errors.ComplianceStandard &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ComplianceStandard &&
                              formikForUpdate.errors.ComplianceStandard && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors.ComplianceStandard
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={12}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">
                              Audit Result
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="AuditResult"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.AuditResult}
                              error={
                                formikForUpdate.touched.AuditResult &&
                                formikForUpdate.errors.AuditResult &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.AuditResult &&
                              formikForUpdate.errors.AuditResult && (
                                <TextError
                                  msg={formikForUpdate.errors.AuditResult}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={12}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">
                              Corrective Actions
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="CorrectiveActions"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.CorrectiveActions}
                              error={
                                formikForUpdate.touched.CorrectiveActions &&
                                formikForUpdate.errors.CorrectiveActions &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "40px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.CorrectiveActions &&
                              formikForUpdate.errors.CorrectiveActions && (
                                <TextError
                                  msg={formikForUpdate.errors.CorrectiveActions}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6" fontWeight={500}>
                              Upload Document
                            </MDTypography>

                            <MDBox
                              display="flex"
                              alignItems="center"
                              width="100%"
                              gap={1}
                            >
                              {/* Hidden file input */}
                              <input
                                id="upload-file"
                                type="file"
                                hidden
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];
                                  formikForUpdate.setFieldValue("file", file);
                                }}
                              />

                              {/* Choose File */}
                              <label htmlFor="upload-file">
                                <MDButton
                                  variant="outlined"
                                  component="span"
                                  color="info"
                                >
                                  Choose File
                                </MDButton>
                              </label>

                              {/* File name – takes remaining width */}
                              <MDBox
                                flex={1}
                                px={2}
                                py={1}
                                sx={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  backgroundColor: "#fafafa",
                                }}
                              >
                                <MDTypography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  title={formikForUpdate.values.file?.name}
                                >
                                  {formikForUpdate.values.file?.name ??
                                    singleFgDataForUpdate?.name ??
                                    "Not Available"}
                                </MDTypography>
                              </MDBox>

                              {/* Upload button */}
                              {/* <MDButton
                                variant="contained"
                                color="success"
                                disabled={
                                  !formikForUpdate.values.file || isUploading
                                }
                                onClick={uploadDocumentHandlerForUpdate}
                              >
                                {isUploading ? "Uploading..." : "Upload"}
                              </MDButton> */}
                            </MDBox>
                          </MDBox>
                        </Grid>
                        {!hideProductImageUrl && (
                          <Grid item xs={12} lg={12}>
                            <MDBox mb={1}>
                              <MDTypography variant="h6">
                                Certificate URL
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="CertificateURL"
                                fullWidth
                                autoComplete="off"
                                onBlur={formikForUpdate.handleBlur}
                                onChange={formikForUpdate.handleChange}
                                value={formikForUpdate.values.CertificateURL}
                                error={
                                  formikForUpdate.touched.CertificateURL &&
                                  formikForUpdate.errors.CertificateURL &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "10px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formikForUpdate.touched.CertificateURL &&
                                formikForUpdate.errors.CertificateURL && (
                                  <TextError
                                    msg={formikForUpdate.errors.CertificateURL}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                        )}

                        {/* EU Battery Regulation Compliance */}
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              EU Battery Regulation Compliance 2023/1542
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              placeholder="Choose one..."
                              name="eUBatteryRegulation"
                              onBlur={() =>
                                formikForUpdate.handleBlur({
                                  target: { name: "eUBatteryRegulation" },
                                })
                              }
                              value={formikForUpdate.values.eUBatteryRegulation}
                              options={euBatteryRegOptions}
                              onChange={(selectedOption) =>
                                formikForUpdate.setFieldValue(
                                  "eUBatteryRegulation",
                                  selectedOption,
                                )
                              }
                            />
                            {formikForUpdate.touched.eUBatteryRegulation &&
                              formikForUpdate.errors.eUBatteryRegulation && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors.eUBatteryRegulation
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Environmental Compliance Declaration */}
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              Environmental Compliance Declaration
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              placeholder="Choose one..."
                              name="environmentalComplianceDeclaration"
                              onBlur={() =>
                                formikForUpdate.handleBlur({
                                  target: {
                                    name: "environmentalComplianceDeclaration",
                                  },
                                })
                              }
                              value={
                                formikForUpdate.values
                                  .environmentalComplianceDeclaration
                              }
                              options={envComplianceOptions}
                              onChange={(selectedOption) =>
                                formikForUpdate.setFieldValue(
                                  "environmentalComplianceDeclaration",
                                  selectedOption,
                                )
                              }
                            />
                            {formikForUpdate.touched
                              .environmentalComplianceDeclaration &&
                              formikForUpdate.errors
                                .environmentalComplianceDeclaration && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors
                                      .environmentalComplianceDeclaration
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Regulation (EU) 2025/606 (Recycling) */}
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              Regulation (EU) 2025/606 (Recycling)
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              placeholder="Choose one..."
                              name="eURecyclingCommissionRegulation"
                              onBlur={() =>
                                formikForUpdate.handleBlur({
                                  target: {
                                    name: "eURecyclingCommissionRegulation",
                                  },
                                })
                              }
                              value={
                                formikForUpdate.values
                                  .eURecyclingCommissionRegulation
                              }
                              options={euRecyclingOptions}
                              onChange={(selectedOption) =>
                                formikForUpdate.setFieldValue(
                                  "eURecyclingCommissionRegulation",
                                  selectedOption,
                                )
                              }
                            />
                            {formikForUpdate.touched
                              .eURecyclingCommissionRegulation &&
                              formikForUpdate.errors
                                .eURecyclingCommissionRegulation && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors
                                      .eURecyclingCommissionRegulation
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Regulation (EU) 2023/1542 - Article 13 - Annex VI */}
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              Regulation (EU) 2023/1542 - Article 13 - Annex VI
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              placeholder="Choose one..."
                              name="euLabelingCompliance"
                              onBlur={() =>
                                formikForUpdate.handleBlur({
                                  target: { name: "euLabelingCompliance" },
                                })
                              }
                              value={
                                formikForUpdate.values.euLabelingCompliance
                              }
                              options={euLabelingOptions}
                              onChange={(selectedOption) =>
                                formikForUpdate.setFieldValue(
                                  "euLabelingCompliance",
                                  selectedOption,
                                )
                              }
                            />
                            {formikForUpdate.touched.euLabelingCompliance &&
                              formikForUpdate.errors.euLabelingCompliance && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors.euLabelingCompliance
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* <Grid item xs={12} lg={6}>
                          <MDBox mb={2} ml={1} >
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Status
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={70}
                              placeholder="Select..."
                              name="location"
                              options={level4Options}
                              value={locationSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeLocationForEdit(selectedOption);
                                formikForUpdateForUpdate.setFieldValue(
                                  "location",
                                  selectedOption
                                );
                              }}
                            />
                            {formikForUpdateForUpdate.touched.location &&
                              formikForUpdateForUpdate.errors.location && (
                                <TextError
                                  msg={formikForUpdateForUpdate.errors.location}
                                />
                              )}
                          </MDBox>
                        </Grid> */}

                        <Grid item xs={12}>
                          <MDBox>
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                        </Grid>
                        {/* <MDBox mt={3} ml={10}> */}

                        {/* <MDButton
                          // variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton> */}

                        {/* Submit Button */}
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Social Compliance Record
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginRight: "10px",
                            marginTop: "4px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            DPP Code{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="DPPID"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "DPPID" },
                              });
                            }}
                            value={dppIdSelected}
                            options={dppOptions}
                            onChange={(selectedOption) => {
                              handleChangeDpp(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Supplier Name{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="supplierId"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "supplierId" },
                              });
                            }}
                            value={supplierIdSelected}
                            options={supplierOptions}
                            onChange={(selectedOption) => {
                              handleChangeSupplier(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "supplierId",
                                selectedOption,
                              );
                            }}
                          />
                          {formik.touched.supplierId &&
                            formik.errors.supplierId && (
                              <TextError msg={formik.errors.supplierId} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox mb={1}>
                          <MDTypography variant="h6">Audit Date</MDTypography>
                          <MDInput
                            type="date"
                            name="AuditDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.AuditDate}
                            error={
                              formik.touched.AuditDate &&
                              formik.errors.AuditDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.AuditDate &&
                            formik.errors.AuditDate && (
                              <TextError msg={formik.errors.AuditDate} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox ml={1} mb={1}>
                          <MDTypography variant="h6">
                            Compliance Standard
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="ComplianceStandard"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ComplianceStandard}
                            error={
                              formik.touched.ComplianceStandard &&
                              formik.errors.ComplianceStandard &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.ComplianceStandard &&
                            formik.errors.ComplianceStandard && (
                              <TextError
                                msg={formik.errors.ComplianceStandard}
                              />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={12} mt={1}>
                        <MDBox mb={1}>
                          <MDTypography variant="h6">Audit Result</MDTypography>
                          <MDInput
                            type="text"
                            name="AuditResult"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.AuditResult}
                            error={
                              formik.touched.AuditResult &&
                              formik.errors.AuditResult &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.AuditResult &&
                            formik.errors.AuditResult && (
                              <TextError msg={formik.errors.AuditResult} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={12} mt={1}>
                        <MDBox mb={1}>
                          <MDTypography variant="h6">
                            Corrective Actions
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="CorrectiveActions"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.CorrectiveActions}
                            error={
                              formik.touched.CorrectiveActions &&
                              formik.errors.CorrectiveActions &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "40px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.CorrectiveActions &&
                            formik.errors.CorrectiveActions && (
                              <TextError
                                msg={formik.errors.CorrectiveActions}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} mt={1}>
                        <MDBox mb={1}>
                          <MDTypography variant="h6" fontWeight={500}>
                            Upload Document
                          </MDTypography>

                          <MDBox
                            display="flex"
                            alignItems="center"
                            width="100%"
                            gap={1}
                          >
                            {/* Hidden file input */}
                            <input
                              id="upload-file"
                              type="file"
                              hidden
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                formik.setFieldValue("file", file);
                              }}
                            />

                            {/* Choose File */}
                            <label htmlFor="upload-file">
                              <MDButton
                                variant="outlined"
                                component="span"
                                color="info"
                              >
                                Choose File
                              </MDButton>
                            </label>

                            {/* File name – takes remaining width */}
                            <MDBox
                              flex={1}
                              px={2}
                              py={1}
                              sx={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                backgroundColor: "#fafafa",
                              }}
                            >
                              <MDTypography
                                variant="body2"
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={formik.values.file?.name}
                              >
                                {formik.values.file?.name || "No file selected"}
                              </MDTypography>
                            </MDBox>

                            {/* Upload button */}
                            {/* <MDButton
                              variant="contained"
                              color="success"
                              disabled={!formik.values.file || isUploading}
                              onClick={uploadDocumentHandler}
                            >
                              {isUploading ? "Uploading..." : "Upload"}
                            </MDButton> */}
                          </MDBox>
                        </MDBox>
                      </Grid>

                      {!hideProductImageUrl && (
                        <Grid item xs={12} lg={12} mt={1}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">
                              Certificate URL
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="CertificateURL"
                              fullWidth
                              autoComplete="off"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.CertificateURL}
                              error={
                                formik.touched.CertificateURL &&
                                formik.errors.CertificateURL &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formik.touched.CertificateURL &&
                              formik.errors.CertificateURL && (
                                <TextError msg={formik.errors.CertificateURL} />
                              )}
                          </MDBox>
                        </Grid>
                      )}
                      {/* <Grid item xs={12} lg={12}>
                              <MDBox ml={1} mb={1} >
                                            <MDTypography variant="h6">Proof Document URL</MDTypography>
                                            <MDInput
                                              type="text"
                                              name="SupplierId"
                                              fullWidth
                                              autoComplete="off"
                                              onBlur={formik.handleBlur}
                                              onChange={formik.handleChange}
                                              value={formik.values.SupplierId}
                                              error={
                                                formik.touched.SupplierId &&
                                                formik.errors.SupplierId &&
                                                true
                                              }
                                              inputProps={{
                                                style: {
                                                  height: "10px",
                                                },
                                                
                                                // maxLength: 45,
                                              }}
                                              
                                            />
                                            {formik.touched.SupplierId &&
                                              formik.errors.SupplierId && (
                                                <TextError msg={formik.errors.SupplierId} />
                                              )}
                                          </MDBox>
                      </Grid>
                      */}
                      {/* <Grid item xs={12} lg={12}>
                      <MDBox mb={2}>
  <MDTypography variant="h6">Assesment Date</MDTypography>
  <MDInput
    type="date"  // Change this from "text" to "date"
    name="Collection"
    fullWidth
    autoComplete="off"
    onBlur={formik.handleBlur}
    onChange={formik.handleChange}
    value={formik.values.Collection}
    error={formik.touched.Collection && formik.errors.Collection && true}
    inputProps={{
      style: {
        height: "10px",
      },
    }}
  />
  {formik.touched.Collection && formik.errors.Collection && (
    <TextError msg={formik.errors.Collection} />
  )}
</MDBox>

                      </Grid> */}
                      {/* <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Warehouse Code{" "}
                          </MDTypography>

                          <Select
                            isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="warehouseCode"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "warehouseCode" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={warehouseOptionsByMovement}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "warehouseCode",
                                selectedOption
                              );
                              getLevel1ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel2ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel3ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel4ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                            }}
                          />
                          {formik.touched.warehouseCode &&
                            formik.errors.warehouseCode && (
                              <TextError msg={formik.errors.warehouseCode} />
                            )}
                        </MDBox>
                      </Grid> */}

                      {/* EU Battery Regulation Compliance */}
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            EU Battery Regulation Compliance 2023/1542
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="eUBatteryRegulation"
                            onBlur={() =>
                              formik.handleBlur({
                                target: { name: "eUBatteryRegulation" },
                              })
                            }
                            value={formik.values.eUBatteryRegulation}
                            options={euBatteryRegOptions}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                "eUBatteryRegulation",
                                selectedOption,
                              )
                            }
                          />
                          {formik.touched.eUBatteryRegulation &&
                            formik.errors.eUBatteryRegulation && (
                              <TextError
                                msg={formik.errors.eUBatteryRegulation}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Environmental Compliance Declaration */}
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            Environmental Compliance Declaration
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="environmentalComplianceDeclaration"
                            onBlur={() =>
                              formik.handleBlur({
                                target: {
                                  name: "environmentalComplianceDeclaration",
                                },
                              })
                            }
                            value={
                              formik.values.environmentalComplianceDeclaration
                            }
                            options={envComplianceOptions}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                "environmentalComplianceDeclaration",
                                selectedOption,
                              )
                            }
                          />
                          {formik.touched.environmentalComplianceDeclaration &&
                            formik.errors
                              .environmentalComplianceDeclaration && (
                              <TextError
                                msg={
                                  formik.errors
                                    .environmentalComplianceDeclaration
                                }
                              />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Regulation (EU) 2025/606 (Recycling) */}
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            Regulation (EU) 2025/606 (Recycling)
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="eURecyclingCommissionRegulation"
                            onBlur={() =>
                              formik.handleBlur({
                                target: {
                                  name: "eURecyclingCommissionRegulation",
                                },
                              })
                            }
                            value={
                              formik.values.eURecyclingCommissionRegulation
                            }
                            options={euRecyclingOptions}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                "eURecyclingCommissionRegulation",
                                selectedOption,
                              )
                            }
                          />
                          {formik.touched.eURecyclingCommissionRegulation &&
                            formik.errors.eURecyclingCommissionRegulation && (
                              <TextError
                                msg={
                                  formik.errors.eURecyclingCommissionRegulation
                                }
                              />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Regulation (EU) 2023/1542 - Article 13 - Annex VI */}
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            Regulation (EU) 2023/1542 - Article 13 - Annex VI
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="euLabelingCompliance"
                            onBlur={() =>
                              formik.handleBlur({
                                target: { name: "euLabelingCompliance" },
                              })
                            }
                            value={formik.values.euLabelingCompliance}
                            options={euLabelingOptions}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                "euLabelingCompliance",
                                selectedOption,
                              )
                            }
                          />
                          {formik.touched.euLabelingCompliance &&
                            formik.errors.euLabelingCompliance && (
                              <TextError
                                msg={formik.errors.euLabelingCompliance}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} mt={1}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      {/* Submit Button */}
                      <MDButton
                        color="info"
                        fullWidth
                        type="submit"
                        disabled={
                          // !formik.isValid ||

                          allocateButtonName === "Please wait..."
                        }
                      >
                        {allocateButtonName}
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getComplianceReducer: state.getComplianceReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getDPPReducer: state.getDPPReducer,
    getDppDocumentsImageReducer: state.getDppDocumentsImageReducer,
    getSupplierTypeReducer: state.getSupplierTypeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getCompliance: (dppId, jwtToken) =>
      dispatch(getCompliance(dppId, jwtToken)),
    getDppIds: (jwtToken) => dispatch(getDppIds(jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createCompliance: (payload, jwtToken) =>
      dispatch(createCompliance(payload, jwtToken)),
    deleteCompliance: (complianceId, jwtToken) =>
      dispatch(deleteCompliance(complianceId, jwtToken)),
    uploadForCompliance: (payload, jwtToken) =>
      dispatch(uploadForCompliance(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editCompliance: (payload, jwtToken) =>
      dispatch(editCompliance(payload, jwtToken)),
    uploadForUrl: (payload, jwtToken) =>
      dispatch(uploadForUrl(payload, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),

    getDppDocumentsImage: (moduleName, type, name, jwtToken) =>
      dispatch(getDppDocumentsImage(moduleName, type, name, jwtToken)),

    getSupplierType: (jwtToken) => dispatch(getSupplierType(jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Compliance);
